

const setSessionTimeoutModalStatus = (context, value) => {
  context.commit('SET_SESSION_TIMEOUT_MODAL_STATUS', value);
};

export default {
  setSessionTimeoutModalStatus,
};
